import { colors } from '@/theme/foundations/colors';

export const jobStatusConfig = {
  draft: {
    id: 'draft',
    color: colors['status-3'],
    label: 'Draft',
    definition: 'Job not published yet',
  },
  published: {
    id: 'published',
    label: 'Open',
    color: colors['status-4'],
    definition: 'Job published and live',
  },
  closed: {
    id: 'closed',
    label: 'Closed',
    color: colors['status-1'],
    definition: 'Job closed',
  },
  pending_approval: {
    id: 'pending_approval',
    label: 'Pending approval',
    color: colors['pastel-11-dark'],
    definition: 'Job pending approval to be published',
  },
  rejected: {
    id: 'rejected',
    label: 'Not approved',
    color: colors['pastel-1-dark'],
    definition:
      'Job not approved for publishing, can be resubmitted if allowed',
  },
  scheduled: {
    id: 'scheduled',
    label: 'Scheduled',
    color: colors['pastel-7-dark'],
    definition:
      'Job approved for publishing and scheduled to publish at a later date',
  },
  archived: {
    id: 'archived',
    label: 'Archived',
    color: colors['secondary-800'],
    definition: '',
  },
};

export const jobsEmploymentsOptions = [
  { label: 'Full Time', value: 'full_time' },
  { label: 'Part Time', value: 'part_time' },
  { label: 'Contract', value: 'contract' },
  { label: 'Internship', value: 'internship' },
  { label: 'Consultant', value: 'consultant' },
  { label: 'Apprentice', value: 'apprentice' },
  { label: 'Temporary', value: 'temporary' },
  { label: 'Seasonal', value: 'seasonal' },
];

export const jobEducationOptions = [
  { label: 'Associate Degree', value: 'associate' },
  { label: "Bachelor's Degree", value: 'bachelor' },
  { label: 'Certification', value: 'certification' },
  { label: 'Doctorate', value: 'doctorate' },
  { label: 'High School or equivalent', value: 'high_school' },
  { label: "Master's Degree", value: 'master' },
];

export const jobExperienceOptions = [
  { label: 'No experience (Intern)', value: 'zero' },
  { label: '0-2 years', value: 'zero_two' },
  { label: '2-5 years', value: 'two_five' },
  { label: '5-10 years', value: 'five_ten' },
  { label: '10-15 years', value: 'ten_fifteen' },
  { label: 'Over 15 years', value: 'over_fifteen' },
];

export const averageTimeInCompanyOptions = [
  { label: '1-2 years', value: 'one_two' },
  { label: '2-3 years', value: 'two_three' },
  { label: '3-4 years', value: 'three_four' },
  { label: '4-5 years', value: 'four_five' },
  { label: 'Over 5 years', value: 'over_five' },
];
